/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiSyncFromJSON, ApiSyncToJSON, } from './ApiSync';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiOauthClientFromJSON(json) {
    return ApiOauthClientFromJSONTyped(json, false);
}
export function ApiOauthClientFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'syncs': !exists(json, 'syncs') ? undefined : (json['syncs'].map(ApiSyncFromJSON)),
        'token': !exists(json, 'token') ? undefined : json['token'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'user': !exists(json, 'user') ? undefined : ApiUserFromJSON(json['user']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userMeta': !exists(json, 'userMeta') ? undefined : json['userMeta'],
    };
}
export function ApiOauthClientToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'externalId': value.externalId,
        'id': value.id,
        'refreshToken': value.refreshToken,
        'scope': value.scope,
        'service': ApiServiceToJSON(value.service),
        'syncs': value.syncs === undefined ? undefined : (value.syncs.map(ApiSyncToJSON)),
        'token': value.token,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'user': ApiUserToJSON(value.user),
        'userId': value.userId,
        'userMeta': value.userMeta,
    };
}
